import { Formik } from "formik";
import WebLayout from "../../layout/WebLayout";
import { API_REQUEST } from "../../redux/actions";
import PanelLayout from "../../layout/PanelLayout";
import { contactUsAPI } from "../../routes/apiURL";
import { helpSupportSchema } from "../../utils/schema";
import ErrorMessage from "../../components/forms/ErrorMessage";
import { pipGetAccessToken, pipGetProfile } from "../../utils/pip";

const HelpSupport = () => {
  const profileData = pipGetProfile();
  const { token } = pipGetAccessToken();
  const initialValues = {
    full_name: profileData?.full_name || "",
    email: profileData?.email || "",
    message: "",
  };

  const handleSupportSubmit = async (values, actions) => {
    actions.setStatus("");

    try {
      const response = await API_REQUEST({
        url: contactUsAPI,
        method: "POST",
        data: values,
        isErrorToast: true,
        isSuccessToast: true,
      });

      if (response?.success) {
        actions.resetForm({
          values: {
            ...initialValues,
            full_name: values.full_name,
            email: values.email,
            message: "",
          },
        });
      } else {
        actions.setStatus(
          response?.message || "Unable to submit your request.",
        );
      }
    } catch (error) {
      actions.setStatus(
        error?.data?.message || "Something went wrong. Please try again.",
      );
    } finally {
      actions.setSubmitting(false);
    }
  };

  const render = () => {
    return <section class="et-contact-wrapper">
      <div class="container">
        <div class="row">
          <div class="col-md-12 text-center mb-5 pb-2">
            <h4 class="ct_fs_26 mb-3 ct_switzer_Semibold">Help & Support</h4>
            <p class="mb-0 ct_fs_16">
              We&apos;re here to help you with your questions and concerns.
            </p>
          </div>
        </div>
        <div class="row g-4 align-items-stretch">
          <div class="col-lg-4">
            <div class="et-contact-card">
              <h4 class="ct_fs_26 ct_switzer_Semibold">Get in Touch With Us</h4>
              <p class="ct_text_4f4f4f">
                Contact our team for support or inquiries.
              </p>

              <div class="ct_mt_30 pt-1">
                <div class="d-flex gap-3 mb-4 align-items-center">
                  <div class="et-icon-box">
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M18.75 9.75C18.75 7.95979 18.0388 6.2429 16.773 4.97703C15.5071 3.71116 13.7902 3 12 3C10.2098 3 8.4929 3.71116 7.22703 4.97703C5.96116 6.2429 5.25 7.95979 5.25 9.75C5.25 12.518 7.46484 16.1273 12 20.4516C16.5352 16.125 18.75 12.5156 18.75 9.75ZM12 22.5C6.5 17.5 3.75 13.25 3.75 9.75C3.75 7.56196 4.61919 5.46354 6.16637 3.91637C7.71354 2.36919 9.81196 1.5 12 1.5C14.188 1.5 16.2865 2.36919 17.8336 3.91637C19.3808 5.46354 20.25 7.56196 20.25 9.75C20.25 13.25 17.5 17.5 12 22.5Z"
                        fill="#32CD30"
                      />
                      <path
                        d="M12 12C12.5967 12 13.169 11.7629 13.591 11.341C14.0129 10.919 14.25 10.3467 14.25 9.75C14.25 9.15326 14.0129 8.58097 13.591 8.15901C13.169 7.73705 12.5967 7.5 12 7.5C11.4033 7.5 10.831 7.73705 10.409 8.15901C9.98705 8.58097 9.75 9.15326 9.75 9.75C9.75 10.3467 9.98705 10.919 10.409 11.341C10.831 11.7629 11.4033 12 12 12ZM12 13.5C11.0054 13.5 10.0516 13.1049 9.34835 12.4017C8.64509 11.6984 8.25 10.7446 8.25 9.75C8.25 8.75544 8.64509 7.80161 9.34835 7.09835C10.0516 6.39509 11.0054 6 12 6C12.9946 6 13.9484 6.39509 14.6517 7.09835C15.3549 7.80161 15.75 8.75544 15.75 9.75C15.75 10.7446 15.3549 11.6984 14.6517 12.4017C13.9484 13.1049 12.9946 13.5 12 13.5Z"
                        fill="#32CD30"
                      />
                    </svg>
                  </div>
                  <p class="et-contact-text">
                    SecurPoint Headquarters <br />
                    123 Security Avenue,
                  </p>
                </div>

                <div class="d-flex gap-3 mb-4 align-items-center">
                  <div class="et-icon-box">
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M4.2 5.2L11.76 10.87C11.8292 10.9219 11.9135 10.95 12 10.95C12.0865 10.95 12.1708 10.9219 12.24 10.87L19.8 5.2H4.2ZM20.8 5.95L12.96 11.83C12.683 12.0377 12.3462 12.15 12 12.15C11.6538 12.15 11.317 12.0377 11.04 11.83L3.2 5.95V18.8H20.8V5.95ZM3 4H21C21.2652 4 21.5196 4.10536 21.7071 4.29289C21.8946 4.48043 22 4.73478 22 5V19C22 19.2652 21.8946 19.5196 21.7071 19.7071C21.5196 19.8946 21.2652 20 21 20H3C2.73478 20 2.48043 19.8946 2.29289 19.7071C2.10536 19.5196 2 19.2652 2 19V5C2 4.73478 2.10536 4.48043 2.29289 4.29289C2.48043 4.10536 2.73478 4 3 4Z"
                        fill="#32CD30"
                      />
                    </svg>
                  </div>
                  <p class="et-contact-text">support@securpoint.com</p>
                </div>

                <div class="d-flex gap-3 mb-4 align-items-center">
                  <div class="et-icon-box">
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M16.6292 13.891L17.0852 13.438L16.0262 12.374L15.5722 12.827L16.6292 13.891ZM18.6142 13.248L20.5252 14.287L21.2402 12.969L19.3302 11.931L18.6142 13.248ZM20.8922 16.351L19.4722 17.764L20.5292 18.827L21.9492 17.415L20.8922 16.351ZM18.6062 18.218C17.1562 18.354 13.4062 18.233 9.34417 14.195L8.28617 15.258C12.7182 19.665 16.9372 19.881 18.7462 19.712L18.6062 18.218ZM9.34417 14.195C5.47317 10.345 4.83117 7.10799 4.75117 5.70299L3.25317 5.78799C3.35317 7.55599 4.14817 11.144 8.28617 15.258L9.34417 14.195ZM10.7192 8.01499L11.0062 7.72899L9.95017 6.66599L9.66317 6.95099L10.7192 8.01499ZM11.2342 4.09399L9.97417 2.40999L8.77317 3.30999L10.0332 4.99299L11.2342 4.09399ZM5.73317 2.04299L4.16317 3.60299L5.22117 4.66699L6.79017 3.10699L5.73317 2.04299ZM10.1912 7.48299C9.66117 6.95099 9.66117 6.95099 9.66117 6.95299H9.65917L9.65617 6.95699C9.60865 7.0049 9.5661 7.05751 9.52917 7.11399C9.47517 7.19399 9.41617 7.29899 9.36617 7.43199C9.24445 7.77532 9.21412 8.1444 9.27817 8.50299C9.41217 9.36799 10.0082 10.511 11.5342 12.029L12.5922 10.965C11.1632 9.54499 10.8232 8.68099 10.7602 8.27299C10.7302 8.07899 10.7612 7.98299 10.7702 7.96099C10.7762 7.94766 10.7762 7.94566 10.7702 7.95499C10.7613 7.96879 10.7512 7.98183 10.7402 7.99399L10.7302 8.00399L10.7202 8.01299L10.1912 7.48299ZM11.5342 12.029C13.0612 13.547 14.2102 14.139 15.0762 14.271C15.5192 14.339 15.8762 14.285 16.1472 14.184C16.299 14.1285 16.4408 14.0488 16.5672 13.948L16.6172 13.903L16.6242 13.897L16.6272 13.894L16.6282 13.892C16.6282 13.892 16.6292 13.891 16.1002 13.359C15.5702 12.827 15.5732 12.826 15.5732 12.826L15.5752 12.824L15.5772 12.822L15.5832 12.817L15.5932 12.807L15.6312 12.777C15.6405 12.771 15.6382 12.7717 15.6242 12.779C15.5992 12.788 15.5012 12.819 15.3042 12.789C14.8902 12.725 14.0202 12.385 12.5922 10.965L11.5342 12.029ZM9.97417 2.40899C8.95417 1.04899 6.95017 0.83299 5.73317 2.04299L6.79017 3.10699C7.32217 2.57799 8.26617 2.63299 8.77317 3.30999L9.97417 2.40899ZM4.75217 5.70399C4.73217 5.35799 4.89117 4.99599 5.22117 4.66799L4.16217 3.60399C3.62517 4.13799 3.20217 4.89399 3.25317 5.78799L4.75217 5.70399ZM19.4722 17.764C19.1982 18.038 18.9022 18.192 18.6072 18.219L18.7462 19.712C19.4812 19.643 20.0822 19.273 20.5302 18.828L19.4722 17.764ZM11.0062 7.72899C11.9912 6.74999 12.0642 5.20299 11.2352 4.09499L10.0342 4.99399C10.4372 5.53299 10.3772 6.23999 9.94917 6.66699L11.0062 7.72899ZM20.5262 14.288C21.3432 14.732 21.4702 15.778 20.8932 16.352L21.9512 17.415C23.2912 16.082 22.8782 13.859 21.2412 12.97L20.5262 14.288ZM17.0852 13.439C17.4692 13.057 18.0872 12.963 18.6152 13.249L19.3312 11.932C18.2472 11.342 16.9032 11.505 16.0272 12.375L17.0852 13.439Z"
                        fill="#32CD30"
                      />
                    </svg>
                  </div>
                  <p class="et-contact-text">+1 234 567 8900</p>
                </div>
              </div>

              <hr style={{ borderColor: "#aaa" }} />

              <p class="fw-bold mt-4 mb-4">Follow our social media</p>

              <div class="et-social-icons">
                <i class="fa-brands fa-instagram"></i>
                <i class="fa-brands fa-facebook-f"></i>
                <i class="fa-brands fa-twitter"></i>
                <i class="fa-brands fa-linkedin-in"></i>
              </div>
            </div>
          </div>

          <div class="col-lg-8">
            <div class="et-contact-card">
              <h4 class="et-contact-title mb-4">Send us a message</h4>

              <Formik
                initialValues={initialValues}
                validationSchema={helpSupportSchema}
                onSubmit={handleSupportSubmit}
                enableReinitialize
              >
                {({
                  values,
                  errors,
                  touched,
                  handleBlur,
                  handleChange,
                  handleSubmit,
                  isSubmitting,
                  status,
                }) => (
                  <form onSubmit={handleSubmit}>
                    <div class="row g-3">
                      <div class="col-md-6">
                        <label class="form-label small">Full Name</label>
                        <input
                          type="text"
                          id="full_name"
                          class="form-control ct_input"
                          placeholder="Enter full name"
                          value={values.full_name}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          disabled={isSubmitting}
                        />
                        <ErrorMessage
                          errors={errors}
                          touched={touched}
                          fieldName="full_name"
                        />
                      </div>

                      <div class="col-md-6">
                        <label class="form-label small">Email</label>
                        <input
                          type="email"
                          id="email"
                          class="form-control ct_input"
                          placeholder="Enter email"
                          value={values.email}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          disabled={isSubmitting}
                        />
                        <ErrorMessage
                          errors={errors}
                          touched={touched}
                          fieldName="email"
                        />
                      </div>

                      <div class="col-12">
                        <label class="form-label small">Message</label>
                        <textarea
                          rows="4"
                          id="message"
                          class="form-control ct_input h-auto"
                          placeholder="Enter here"
                          value={values.message}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          disabled={isSubmitting}
                        ></textarea>
                        <ErrorMessage
                          errors={errors}
                          touched={touched}
                          fieldName="message"
                        />
                      </div>

                      {status ? (
                        <div class="col-12">
                          <span style={{ color: "red" }}>{status}</span>
                        </div>
                      ) : null}

                      <div class="col-12 mt-4">
                        <button
                          type="submit"
                          class="ct_green_bnt px-5"
                          disabled={isSubmitting}
                        >
                          {isSubmitting ? "Submitting..." : "Submit"}
                        </button>
                      </div>
                    </div>
                  </form>
                )}
              </Formik>
            </div>
          </div>
        </div>
      </div>
    </section>;
  };

  return token ? (
    <PanelLayout>{render()}</PanelLayout>
  ) : (
    <WebLayout>{render()}</WebLayout>
  );
};

export default HelpSupport;
